<script>
  export default {
    name: 'CoachingCalendar',

    computed: {
      events() {
        return this.$store.getters['api/events']
      }
    }
  }
</script>

<template>
  <VSheet class="fill-height pa-8">
    <VCalendar v-if="events.length" :events="events" :weekdays="[1, 2, 3, 4, 5]"/>
  </VSheet>
</template>
